<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col col-lg-6">
        <div class="boxy">
          <h1>404</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error-404",
  mounted() {
    this.$Progress.finish();
  },
  beforeRouteEnter(to, from, next) {
    document.body.style.backgroundColor = "#eeeeee";
    next();
  },
  beforeRouteLeave(to, from, next) {
    document.body.style.backgroundColor = "#ffffff";
    next();
  }
};
</script>

<style lang="scss" scoped>
.boxy {
  background-color: #fff;
  padding: 2em;
}
</style>
